module.exports = __webpack_public_path__ + "img/tu4.820012fa.jpg";